<template>
  <el-header class="web-header" style="height: 61px">
    <div class="layout-container">
      <div class="container">
        <div class="logo">
          <router-link to="/index">
            <el-image :src="logoSrc"></el-image>
          </router-link>
        </div>
        <!-- 导航 -->
        <navigator class="nav"></navigator>
        <!-- 按钮组 -->
        <div class="button-group">
          <el-button type="primary" @click="goLogin()" v-show="!nick">
            登录
          </el-button>
          <el-button type="text" @click="goLogin('supply')" v-show="!nick">
            注册
          </el-button>
          <el-link class="nick" type="primary" href="/home" v-show="nick">
            {{ nick }}
          </el-link>
          <el-link
            type="info"
            v-show="nick"
            @click="logout"
            style="margin-left: 10px"
            >退出</el-link
          >
        </div>
      </div>
    </div>
  </el-header>
</template>

<script>
import Navigator from "./Navigator";
import { getUserInfo } from "@/utils/user";
export default {
  data() {
    return {
      nick: "",
      logoSrc: "//img.oceanz.cn/web/logo_1.png",
    };
  },
  components: {
    Navigator,
  },
  async mounted() {
    const userInfo = getUserInfo();
    if (userInfo) {
      this.nick = userInfo.nick;
    }
  },
  methods: {
    goLogin(activeName) {
      this.$router.push({
        name: "login",
        params: {
          activeName,
        },
      });
    },
    logout() {
      this.$store.dispatch("logOut").then(() => {
        location.reload();
      });
    },
  },
};
</script>

<style lang="scss">
.web-header {
  position: fixed;
  width: 100%;
  border-bottom: 1px solid #eee;
  background: #fff;
  z-index: 1000;
  display: flex;
  align-items: center;
  .layout-container {
    .container {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .nav {
      display: flex;
      flex: 1;
      justify-content: space-between;
    }
    .logo {
      width: 144px;
      height: 48px;
      img {
        width: 100%;
      }
    }
    .button-group {
      display: flex;
      align-items: center;
      .nick {
        font-size: 18px;
      }
    }
    .el-button {
      width: 80px;
      height: 28px;
      line-height: 28px;
      padding: 0;
      &::after {
        display: none;
      }
    }
  }
}
</style>
